export const UNAVAILABLE_TABLE_VALUE = '-';
